<div class="header">
    <div class="header-left"><a href="#"><img alt="RestoreID" src="assets/images/restoreid-logo.jpg"></a></div>
    <div class="header-right">
        <div><app-menu-bar *ngIf="!isLoginRoute()"></app-menu-bar></div>
        <div><app-top-bar></app-top-bar></div>
    </div>
</div>
